import { FunctionComponent } from 'react';
import { Educator } from '@shared/types';
import styles from './styles.module.scss';
import StarRatingWithCount from '../../../../components/StarRatingWithCount';
import Link from 'next/link';

type EducatorHeaderCardProps = {
    name: Educator['name'];
    slug: Educator['slug'];
    overall_review_aggregate?: Educator['overall_review_aggregate'];
};

export const EducatorHeaderCard: FunctionComponent<EducatorHeaderCardProps> = ({
    name,
    slug,
    overall_review_aggregate,
}) => {
    return (
        <div className={styles.card}>
            <div className={styles.educatorContainer}>
                <div className={styles.educatorInfo}>
                    <h4>
                        By <Link href={`/${slug}/courses`}>{name}</Link>
                    </h4>
                    {overall_review_aggregate && overall_review_aggregate.count > 0 ? (
                        <StarRatingWithCount
                            rating={overall_review_aggregate.rating}
                            count={overall_review_aggregate.count}
                        />
                    ) : null}
                </div>
            </div>
        </div>
    );
};
